export const SET_LENDERS = 'SET_LENDERS';
export const SET_INFO = 'SET_INFO';
export const SET_SEARCH_AGENTS = 'SET_SEARCH_AGENTS';
